<ng-container [formGroup]="parentFormGroup">
  <div class="row">
    <div class="col-md-{{colSize}}">
      @if (usNonprofitSelected) {
        <yc-typeahead-select
          name="ntee"
          [items]="nteeOptions"
          [disabled]="disableNtee"
          [label]="'nonprofits:textNteeCode' | ycI18n: 'NTEE Code'">
        </yc-typeahead-select>
      }

      @if (!usNonprofitSelected) {
        <yc-typeahead-select
          name="category"
          [label]="'nonprofits:lbCategory' | ycI18n: 'Category'"
          [items]="classificationOptions"
          [disabled]="disableNtee"
          (onChange)="classificationChanged()">
        </yc-typeahead-select>
        @if (parentFormGroup.value.category?.children?.length) {
          <yc-typeahead-select
            name="group"
            [label]="'nonprofits:lblGroup' | ycI18n: 'Group'"
            [items]="groupSelectOptions"
            [disabled]="disableNtee"
            (onChange)="classificationChanged()">
          </yc-typeahead-select>
        }
      }
    </div>
  </div>
</ng-container>
